import React, {useEffect, useState} from "react";

export default function ClassicoHoseFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <g>
          <path
            fill={lightContrast}
            onClick={() => handleClick("base")}
            onMouseEnter={() => setLightContrastActive(true)}
            onMouseLeave={() => setLightContrastActive(false)}
            style={
              lightContrastActive && !preview
                ? {fill: adjust(lightContrast, 55)}
                : {fill: lightContrast}
            }
            d="M242.415,410.224c-0.04-0.42-4.39-42.21-7.2-59.91c-1.79-11.29-5.27-25.36-7.87-35.18
     c-1.42-5.35-2.1-10.88-2.03-16.43c0.14-9.97,0.25-22.65-0.02-26.37c-0.32-4.27-1.29-19.11-0.48-30.95
     c0.14-1.94,0.32-4.31,0.52-7.02c0.96-12.59,2.56-33.67,2.47-52.34c-0.09-18.08,0.86-30.26,1.27-34.66
     c0.08-0.83,0.23-1.65,0.44-2.44c2.07-7.58,11.12-47.72-14.18-94.17l-3.25-6.94c0.02-0.09,0.01-0.2-0.04-0.34
     c-1.35-3.41-2.4-7.25-3.31-12.1l-0.33-1.6c-0.28-1.4-0.56-2.8-0.82-4.2c-0.17-0.9-0.37-1.58-0.83-1.99
     c-0.47-0.43-1.14-0.53-2.17-0.33c-24.39,4.58-46.63,9.73-68,15.74c-2.88,0.82-5.75,1.6-8.6,2.38c-6.91,1.9-14.05,3.86-21.13,6.12
     c-0.35,0.14-0.59,0.48-0.59,0.86v19.11h0.02c0.08,2.96,0.57,21.5,1.04,36.44l0.01,0.27l-0.81,1.38c-0.8,1.38-1.59,2.77-2.39,4.16
     c-1.24,2.18-2.47,4.37-3.69,6.57c-1.61,2.88-3.2,5.77-4.77,8.67c-1.88,3.46-3.77,6.99-5.62,10.49c-2.1,4-4.2,8.03-6.21,11.99
     c-2.26,4.44-4.48,8.88-6.59,13.2c-2.33,4.75-4.59,9.5-6.73,14.1c-2.32,4.99-4.55,9.94-6.64,14.72c-2.24,5.14-4.36,10.2-6.3,15.03
     c-2.12,5.26-4,10.18-5.75,15.04c-1.87,5.19-3.49,10.01-4.95,14.76c-1.55,5.02-2.83,9.65-3.92,14.16l-0.15,0.61
     c-1.08,4.48-2.2,9.1-2.62,13.69c-0.22,2.35-0.19,4.73-0.16,7.03c0.01,0.77,0.02,1.53,0.02,2.29l0.02,4.76
     c0.01,3.87,0.02,7.75,0.04,11.63c0.02,4.56,0.05,9.12,0.08,13.68c0.04,4.93,0.08,9.87,0.13,14.8c0.05,4.99,0.11,9.99,0.18,14.98
     c0.07,4.74,0.15,9.48,0.24,14.22c0.1,4.85,0.21,8.83,0.32,12.54c0.1,2.93,0.22,6.41,0.41,9.91l0.01,0.22
     c0.11,2.02,0.22,4.1,0.48,6.14c0.05,0.34,0.1,0.68,0.16,1.01c1.88,9.72,1.89,29.87,0.98,38.2c-0.87,7.9,1.18,32.76,1.2,33.01
     l0.01,0.18l0.17,0.08c0.09,0.05,9.77,4.85,25.07,4.85c0.49,0,0.98,0,1.48-0.01c15.25-0.31,25.45-0.73,35.6-2.09
     c9.67-1.29,10.38-3.59,10.43-3.91c0-0.35,0.12-35.51,1.2-50.6c0.63-8.76,1.17-18.19,1.67-28.85c0.36-7.68,0.71-15.87,0.83-24.1
     c0.05-3.48,0-6.99-0.04-10.39c-0.1-7.36-0.2-14.97,0.69-22.53c1.71-14.56,4.69-29.14,7.56-43.25l1.04-5.1
     c0.85-4.19,2.2-8.64,5.67-10.28c0.64,3.22,4.86,24.8,5.61,31.16c0.74,6.34,5.33,42.38,6.31,50.01
     c0.97,7.57,12.34,59.26,12.46,59.78c0.09,0.39,9.28,38.57,10.68,54.72c1.42,16.37,4.81,31.3,5.42,32.04
     c0.45,0.53,8.59,2.99,21.13,3.4c1.14,0.04,2.34,0.06,3.6,0.06c11.72,0,28.74-1.82,48.52-9.48l0.22-0.08l-0.02-0.24
     C249.185,463.794,242.485,410.755,242.415,410.224z"
          />
          <path
            fill={lightContrast}
            onClick={() => handleClick("base")}
            onMouseEnter={() => setLightContrastActive(true)}
            onMouseLeave={() => setLightContrastActive(false)}
            style={
              lightContrastActive && !preview
                ? {fill: adjust(lightContrast, 55)}
                : {fill: lightContrast}
            }
            d="M482.055,185.094c-0.27-11.88-0.53-23.3-0.76-33.66c-0.09-4.34-0.18-8.49-0.25-12.41
     c-0.8-40.59-5.74-68.72-9.74-85.17c-0.85-3.47-1.18-7.11-1.01-10.81c0.45-9.46-1.33-18.99-1.93-20.96v-0.08h-0.02
     c-0.06-0.17-0.1-0.26-0.13-0.28l-0.1-0.06l-0.06-0.04l-0.04,0.02c-83.82-16.61-161.56-0.74-165.03-0.01l-0.02-0.01l-0.06,0.03
     c-0.01,0-0.03,0.01-0.04,0.01v0.01l-0.07,0.04c-0.03,0.02-0.07,0.12-0.13,0.29l-0.02,0.08c-0.58,1.83-2.11,10.26-2,18.71
     c0.07,5.57-0.5,11.04-1.69,16.24c-3.68,16.09-8.23,43.37-8.99,81.99c-0.26,13.3-0.63,29.23-1.01,46.09
     c-1.39,60.59-2.95,129.27-1.34,137.33c0.8,3.99,0.93,26.54,1.09,52.65c0.25,41.67,0.56,93.53,3.64,101.87l0.05,0.15l0.16,0.04
     c0.2,0.07,13.48,4.06,34.1,4.06c10.36,0,22.59-1.01,35.93-4.04c0.33,0,0.33,0,0.62-5.15c0.17-3.08,0.4-7.48,0.68-12.75
     c0.55-10.56,1.27-24.64,1.99-38.71c1.44-28.15,2.86-56.31,2.86-56.31c0.03-0.83,3.52-83.83,2.65-118.2
     c1.16-26.2,7.3-51.57,7.37-51.89c0.275-7.18,0.919-16.007,1.922-23.407h0.054v-0.386c1.142-8.263,2.737-14.655,4.774-14.797
     c3.81,0.26,6.07,22.35,6.72,37.77c0,0.09-0.01,0.16-0.01,0.17h0.02c0.01,0.24,0.02,0.48,0.03,0.72
     c0.06,0.25,6.19,25.62,7.36,51.79c-0.88,34.4,2.62,117.4,2.65,118.23c0,0,1.42,28.16,2.86,56.31c0.72,14.07,1.44,28.15,1.99,38.71
     c0.28,5.27,0.51,9.67,0.68,12.75c0.29,5.15,0.27,5.15,0.55,5.14c39.93,9.05,69.8,0.09,70.1-0.01l0.15-0.04l0.06-0.15
     c3.08-8.34,3.39-60.2,3.64-101.87c0.16-26.11,0.29-48.66,1.09-52.65C485.005,314.384,483.435,245.704,482.055,185.094z"
          />
        </g>
        <path
          fill="#F4F4F4"
          d="M223.48,70.207l-31.91,3.21l-0.08-0.84l31.71-3.11C223.299,69.717,223.39,69.967,223.48,70.207"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M177.48,120.637c-16.64-13.6-25.93-52.19-28.53-64.48c1.53-0.38,3-0.74,4.39-1.09l5.13-1.2
   c5.28-1.24,10.26-2.32,13.31-2.87c0.96-0.18,1.93-0.35,2.89-0.52C182.16,77.947,181.39,88.667,177.48,120.637"
        />
        <polygon
          fill="#F4F4F4"
          points="188.529,153.207 140.169,158.947 140.019,157.657 188.399,152.127 	"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M230.75,98.518l-29.24,2.93c-0.72-0.53-5.31-4.01-7.08-5.35l-0.01-0.03h-0.03
   c-0.26-0.19-0.46-0.35-0.57-0.43l-2.18-21.58l32.07-3.22C227.32,80.678,229.52,89.997,230.75,98.518"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M192.25,185.028c-0.21,0.33-1.12,1.47-2,2.57c-1.53,1.92-2.65,3.34-2.97,3.9l-38.08,4.5
   c-0.43-0.53-1.79-1.8-3.12-3.02c-0.99-0.93-2.02-1.88-2.17-2.04l-3.66-31.35l48.35-5.74L192.25,185.028z"
        />
        <path
          fill="#010101"
          d="M110.5,51.378c-1.12,0-1.97,1.829-1.97,4.25c0,2.42,0.85,4.25,1.97,4.25c1.12,0,1.97-1.83,1.97-4.25
   C112.47,53.207,111.62,51.378,110.5,51.378 M110.5,59.228c-0.62,0-1.32-1.54-1.32-3.6s0.7-3.6,1.32-3.6c0.62,0,1.32,1.54,1.32,3.6
   S111.12,59.228,110.5,59.228"
        />
        <path
          fill="#010101"
          d="M119.23,48.758c-1.13,0-1.97,1.83-1.97,4.25c0,2.43,0.84,4.25,1.97,4.25c1.12,0,1.97-1.82,1.97-4.25
   C121.2,50.588,120.35,48.758,119.23,48.758 M119.23,56.608c-0.63,0-1.32-1.54-1.32-3.6s0.69-3.6,1.32-3.6
   c0.62,0,1.32,1.54,1.32,3.6S119.85,56.608,119.23,56.608"
        />
        <path
          fill="#F4F4F4"
          d="M336.629,150.028v1.31l-46.27-0.17c0.01-0.38,0.02-0.76,0.02-1.14H336.629z"
        />
        <path
          fill="#F4F4F4"
          d="M480.64,151.148l-43.39,0.19c0-0.06,0.01-0.1,0.01-0.16c0.03-0.36,0.08-0.96,0.17-1.15h43.18
   C480.62,150.408,480.63,150.768,480.64,151.148"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M481.489,189.028l-38.23,0.14c-0.43-0.55-1.99-1.99-3.51-3.38c-1.07-0.99-2.17-2-2.42-2.31l-0.11-31.49
   l43.43-0.19c0.22,10.27,0.48,21.57,0.75,33.32C481.429,186.408,481.459,187.718,481.489,189.028"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M336.62,151.988l-0.1,31.49c-0.26,0.31-1.36,1.32-2.43,2.31c-1.52,1.39-3.08,2.83-3.5,3.38l-41.08-0.12
   c0.03-1.31,0.06-2.62,0.09-3.92c0.27-11.75,0.53-23.04,0.75-33.31L336.62,151.988z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M479.359,114.778c-0.39-0.96-0.78-1.91-1.15-2.86c-0.22-0.56-0.44-1.12-0.65-1.68
   c-0.34-0.88-0.68-1.76-1.01-2.63c-0.28-0.76-0.57-1.53-0.85-2.3c-0.19-0.51-0.37-1.03-0.55-1.54
   c-6.05-16.91-11.07-35.93-15.23-57.72l1.12-0.02c4.29-0.06,7.77-0.09,8.57-0.1c0.07,2.76,0.42,5.47,1.06,8.08
   C473.809,66.928,477.529,87.058,479.359,114.778"
        />
        <path
          fill={darkenColor}
          d="M467.509,22.207c-2.45,3.54-8.81,3.521-8.87,3.53l-73.15-0.52l-73.48,0.74c-0.06,0-6.11-0.189-8.53-3.76
   C310.149,20.837,385.879,6.127,467.509,22.207"
        />
        <path
          fill="#010101"
          d="M379.85,32.288c-1.74,0-3.15,1.42-3.15,3.16c0,1.74,1.41,3.15,3.15,3.15c1.74,0,3.16-1.41,3.16-3.15
   C383.01,33.707,381.59,32.288,379.85,32.288 M379.85,37.947c-1.38,0-2.5-1.12-2.5-2.5c0-1.39,1.12-2.51,2.5-2.51
   c1.39,0,2.51,1.12,2.51,2.51C382.36,36.827,381.24,37.947,379.85,37.947"
        />
        <path
          fill="#010101"
          d="M393.96,32.288c-1.74,0-3.16,1.42-3.16,3.16c0,1.74,1.42,3.15,3.16,3.15c1.74,0,3.16-1.41,3.16-3.15
   C397.12,33.707,395.7,32.288,393.96,32.288 M393.96,37.947c-1.38,0-2.51-1.12-2.51-2.5c0-1.39,1.13-2.51,2.51-2.51
   c1.38,0,2.51,1.12,2.51,2.51C396.469,36.827,395.339,37.947,393.96,37.947"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="334.245"
          y1="156.354"
          x2="290.47"
          y2="156.354"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M343.377,44.697
   c13.548,0.207,27.205,0.404,27.212,0.36"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M301.968,43.635
   l6.764,0.319l8.073,0.327c0,0,4.793,0.077,11.518,0.183"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="343.301"
          y1="27.435"
          x2="370.589"
          y2="27.153"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M303.495,25.516
   c2.728,1.855,6.04,2.182,6.04,2.182h8.252l10.463-0.108"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M442.313,27.756
   l10.319,0.052h8.728c0,0,3.293-0.61,6.328-1.964"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M427.252,44.271
   l-50.757,0.834h-1.201l-0.652-0.756c-0.643-1.178-1.289-2.353-1.916-3.533c-0.836-1.571-1.189-3.391-1.037-5.161
   c0.143-1.657,0.79-2.905,1.597-4.302l1.456-2.523l0.697-1.269l1.056-0.136l50.757,0.255"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          points="
   468.888,43.845 461.801,43.845 453.178,43.845 442.23,44.025 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="333.52"
          y1="27.008"
          x2="333.52"
          y2="47.032"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="337.462"
          y1="27.008"
          x2="337.462"
          y2="47.032"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="432.527"
          y1="27.008"
          x2="432.527"
          y2="47.032"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="436.297"
          y1="27.008"
          x2="436.297"
          y2="47.032"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.237,0.928"
          d="
   M291.057,466.113c0,0,31.871,9.4,72.185,0.262"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.237,0.928"
          d="
   M479.941,466.113c0,0-32.045,9.4-72.359,0.262"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M385.499,129.456c0.144-0.044,0.291-0.091,0.442-0.139"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="386.818"
          y1="129.029"
          x2="386.819"
          y2="129.029"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M386.819,129.029c2.723-0.228,7.427-0.429,10.464-0.543c1.814-0.069,2.65-1.52,2.74-3.135c0.136-2.427,0.033-4.896,0.034-7.326
   c0.003-7.235-0.128-14.467-0.111-21.701c0.008-3.249,0.016-6.499,0.024-9.748l0.025-10.264c0.008-3.309,0.016-6.618,0.024-9.928
   c0.007-2.912,0.014-5.825,0.021-8.737c0.005-2.232,0.01-4.464,0.016-6.695c0.003-1.266,0.006-2.532,0.009-3.798
   c0-0.027,0.001-0.055,0.001-0.082"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M400.066,47.071
   c0-0.155,0-0.31,0.001-0.464"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="386.97"
          y1="47.029"
          x2="386.97"
          y2="47.493"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="386.969"
          y1="48.411"
          x2="386.969"
          y2="48.412"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          points="
   386.969,48.412 386.896,128.931 386.896,147.713 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="386.896"
          y1="147.713"
          x2="386.896"
          y2="148.177"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="0.928,0.928"
          d="
   M391.932,180.245c0.415-9.064,0.996-22.995,0.755-25.231c-0.361-3.36-4.913-5.506-7.035-4.873h-0.093
   c-2.122-0.633-6.674,1.513-7.035,4.873c-0.237,2.207,0.325,15.798,0.739,24.867"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="0.928,0.928"
          d="M380.501,170.76
   v-12.569c0-1.616,0.602-3.19,1.742-4.335c0.784-0.787,1.769-1.213,3.193-1.228"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="0.928,0.928"
          d="
   M390.672,170.871l-0.175-12.744c0-1.615-0.601-3.19-1.742-4.335c-0.784-0.787-1.769-1.213-3.192-1.228"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="389.514"
          y1="129.44"
          x2="389.514"
          y2="149.281"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M315.468,45.866
   c-4.261,22.377-10.138,46.542-20.145,70.62l-2.187-1.011"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M295.323,116.486c0,0-1.438,2.73-2.935,3.853"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M455.439,45.866
   c4.261,22.377,10.138,46.542,20.146,70.62l2.186-1.011"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M475.584,116.486c0,0,1.438,2.73,2.934,3.853"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M400.63,264.101
   c0.196,0.03,0.394,0.06,0.593,0.09"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="402.401"
          y1="264.36"
          x2="402.41"
          y2="264.361"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.2,1.189"
          d="M402.41,264.361
   c10.123,1.404,24.976,2.235,36.638,2.235c16.632,0,34.431-1.48,42.378-2.422"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M481.432,264.173
   c0.206-0.024,0.404-0.048,0.596-0.072"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M400.742,259.756
   c0.197,0.033,0.395,0.066,0.594,0.099"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="402.509"
          y1="260.043"
          x2="402.515"
          y2="260.044"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.2,1.189"
          d="M402.516,260.044
   c10.372,1.614,24.065,2.582,36.532,2.582c18.327,0,35.423-1.891,42.377-2.791"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M481.431,259.834
   c0.208-0.027,0.407-0.053,0.596-0.078"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M288.464,264.436
   c0.196,0.03,0.395,0.06,0.594,0.089"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="290.235"
          y1="264.695"
          x2="290.24"
          y2="264.696"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.2,1.189"
          d="M290.24,264.696
   c10.036,1.413,24.205,2.565,35.833,2.565c16.439,0,34.922-1.577,43.107-2.524"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M369.188,264.736
   c0.205-0.024,0.404-0.047,0.596-0.07"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M288.464,259.592
   c0.197,0.033,0.396,0.065,0.595,0.098"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="290.238"
          y1="259.879"
          x2="290.245"
          y2="259.88"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.206,1.195"
          d="M290.246,259.88
   c10.312,1.625,23.36,2.91,35.827,2.91c17.97,0,36.121-1.972,43.486-2.893"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M369.563,259.896
   c0.207-0.026,0.406-0.051,0.595-0.075"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M439.959,187.649c0.013,16.676,0.013,39.871,0.123,56.538c3.573-0.016-0.006-3.007,0,0c12.984-0.581,28.696-0.207,41.946-0.173"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M480.902,187.629c-11.75-0.139-24.47,0.609-36.067,0.235c-2.245-1.122-3.741-3.367-5.611-4.863
   c-1.123-10.101,0-20.576-0.385-30.658"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M439.597,156.354c13.469,0.086,27.311,0.086,40.886,0"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M333.883,190.267c0.095,12.707,0,33.331-0.068,45.517c-0.028,4.819-0.05,8.742-0.055,11.395l-4.929-0.035"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M289.718,187.616l39.923,0.121c0.656-0.652,4.619-4.318,5.26-4.949l0.101-30.444"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="293.328"
          y1="199.087"
          x2="289.486"
          y2="199.087"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          points="
   319.967,199.087 326.148,199.087 326.148,248.816 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M317.639,194.016v35.692c0,0.237-0.227,0.43-0.505,0.43h-21.447c-0.278,0-0.505-0.193-0.505-0.43v-35.692"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="295.227"
          y1="232.362"
          x2="295.227"
          y2="248.365"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="317.639"
          y1="232.324"
          x2="317.639"
          y2="248.327"
        />

        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
   400.094,123.006 399.168,123.932 400.094,123.932 399.205,124.821 400.094,124.821 398.983,125.932 400.094,125.932 
   398.965,127.062 400.094,127.062 399.002,128.154 400.094,128.154 	"
        />

        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
   387.461,123.006 386.535,123.932 387.461,123.932 386.572,124.821 387.461,124.821 386.35,125.932 387.461,125.932 
   386.331,127.062 387.461,127.062 386.368,128.154 387.461,128.154 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M173.912,467.793c0,0,0.207,0.042,0.6,0.113"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="175.732"
          y1="468.118"
          x2="175.732"
          y2="468.118"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.241,1.239"
          d="
   M175.733,468.118c6.648,1.111,30.208,4.377,49.216-1.396"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M224.95,466.722
   c0.195-0.06,0.389-0.12,0.583-0.181"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="231.905"
          y1="464.734"
          x2="231.906"
          y2="464.734"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.175,1.173"
          d="
   M226.223,466.358c3.684-1.124,17.985-5.441,21.212-7.002"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M247.436,459.356
   c0.203-0.098,0.384-0.192,0.542-0.28"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.221,1.221"
          d="M43.898,437.057
   c0,0,19.014,6.969,40.089,4.161"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.221,1.221"
          d="M84.603,441.14
   c0,0,23.87-1.699,32.202-4.669"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="116.503"
          y1="65.198"
          x2="116.516"
          y2="65.661"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="116.541"
          y1="66.58"
          x2="116.541"
          y2="66.581"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="0.921,0.919"
          d="M116.541,66.582
   c0.059,2.129,0.118,4.259,0.176,6.388c0.138,4.974,0.275,9.949,0.412,14.924c0.158,5.699,0.315,11.398,0.473,17.097
   c0.124,4.504,0.279,9.008,0.567,13.504c0.287,4.467,0.861,8.913,1.084,13.383c0.007,0.136,0.013,0.271,0.018,0.408
   c0.034,0.977,0.056,1.967,0.037,2.947c-0.03,1.472-1.022,2.743-2.441,3.133c-1.582,0.434-3.752,0.688-5.725,1.051"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M111.142,139.417
   c-0.147,0.042-0.297,0.081-0.449,0.115"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          points="
   183.615,29.365 187.633,28.571 205.525,25.189 	"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          points="
   136.806,40.852 149.667,37.19 157.195,35.335 172.77,31.748 	"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="107.902"
          y1="49.082"
          x2="128.706"
          y2="43.158"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M188.29,45.927
   l1.961-0.336c0,0,8.183-1.31,19.202-3.164"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M138.682,56.74
   l12.73-3.403l7.769-1.815c0,0,9.482-2.384,18.62-3.907"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="107.902"
          y1="64.969"
          x2="131.253"
          y2="58.726"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M228.422,145.088l-20.394,2.056c-1.64-1.623-4.817-4.777-6.267-6.221l-3.857-37.929c0.151,0.114,0.295,0.222,0.431,0.324
   c0.373,0.281,0.683,0.513,0.901,0.677c0.114,0.084,0.208,0.155,0.277,0.205c0.686,0.504,1.43,0.721,2.212,0.644
   c0.044-0.004,0.088-0.009,0.133-0.016l29.029-2.906"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M228.189,146.981l-20.845,2.101c-1.422-1.403-6.143-6.089-7.366-7.31l-4.356-42.833c0.627,0.474,1.111,0.839,1.125,0.85
   c0.984,0.744,1.968,1.486,2.707,2.043c0.37,0.278,0.679,0.509,0.896,0.671c0.109,0.082,0.197,0.148,0.26,0.193
   c0.131,0.098,0.467,0.342,0.934,0.296c0.027-0.002,0.053-0.006,0.08-0.011l29.168-2.919"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M230.203,95.805
   l-27.626,2.766c-1.257-0.946-5.89-4.687-5.89-4.687l-1.757-17.387l29.521-2.964"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M230.331,97.661
   l-28.567,2.86c-1.088-0.812-4.357-3.285-6.484-4.897l-0.615-0.514l-2.051-20.251l31.895-3.202"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="200.315"
          y1="118.002"
          x2="231.869"
          y2="114.909"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M145.178,57.302
   c0.041,0.197,0.083,0.394,0.125,0.591"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="145.552"
          y1="59.058"
          x2="145.554"
          y2="59.068"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.201,1.19"
          d="M145.554,59.068
   c5.336,24.671,15.287,53.107,28.805,63.703c0,0,1.307,1.298,3.015,1.659"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M177.374,124.429
   c0.196,0.042,0.397,0.07,0.603,0.083"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M146.676,197.391c1.368,12.633,2.977,26.054,4.415,38.155c0.568,4.785,1.031,8.681,1.335,11.317l33.487-4.014l32.19-3.679
   l-8.904-77.918"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="192.736"
          y1="179.909"
          x2="210.048"
          y2="177.931"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="192.255"
          y1="175.697"
          x2="209.566"
          y2="173.719"
        />
        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
   208.294,160.844 209.893,161.436 208.371,161.424 210.014,162.398 208.492,162.386 210.115,163.168 208.592,163.157 
   210.214,163.938 208.693,163.927 210.313,164.708 208.792,164.698 210.412,165.478 208.893,165.468 210.511,166.247 	"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M187.154,154.398l3.555,30.406c-0.378,0.499-3.641,4.591-4.195,5.345l-36.795,4.347c-0.589-0.588-4.116-3.875-4.691-4.444
   l-3.536-30.239"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="142.542"
          y1="163.729"
          x2="187.256"
          y2="158.62"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="192.809"
          y1="187.051"
          x2="198.862"
          y2="240.023"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          x1="176.791"
          y1="121.461"
          x2="173.693"
          y2="121.461"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M136.748,61.882
   c-0.089-0.165-0.173-0.354-0.25-0.553"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="136.138"
          y1="60.216"
          x2="136.136"
          y2="60.207"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.179,1.168"
          d="M136.135,60.207
   c-0.109-0.403-0.172-0.698-0.172-0.698s-2.642-12.76-2.823-15.476c-0.065-0.984,0.048-1.772,0.218-2.377"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M133.357,41.659
   c0.06-0.213,0.126-0.403,0.195-0.571"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M134.878,62.574
   c-0.089-0.165-0.173-0.354-0.25-0.553"
        />
        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="134.269"
          y1="60.908"
          x2="134.266"
          y2="60.9"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.179,1.168"
          d="M134.266,60.9
   c-0.109-0.403-0.172-0.698-0.172-0.698s-2.642-12.76-2.823-15.477c-0.065-0.983,0.048-1.771,0.218-2.377"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M131.488,42.352
   c0.06-0.212,0.126-0.402,0.195-0.57"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M182.058,51.109
   c0.037-0.186,0.058-0.392,0.065-0.604"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          x1="182.072"
          y1="49.316"
          x2="182.071"
          y2="49.306"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.2,1.189"
          d="M182.071,49.306
   c-0.045-0.422-0.101-0.724-0.101-0.724s-2.503-12.967-3.526-15.54c-0.38-0.955-0.901-1.619-1.405-2.076"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M177.042,30.969
   c-0.159-0.145-0.317-0.269-0.468-0.374"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M184.461,50.897
   c0.04-0.186,0.062-0.391,0.072-0.603"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="0.01,0"
          x1="184.491"
          y1="49.075"
          x2="184.49"
          y2="49.065"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.23,1.219,0.01,0"
          d="
   M184.49,49.066c-0.044-0.439-0.102-0.755-0.102-0.755s-2.515-13.271-3.563-15.901c-0.393-0.986-0.938-1.666-1.464-2.131"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          d="M179.364,30.281
   c-0.161-0.142-0.32-0.264-0.473-0.369"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M192.254,255.146c-18.208,3.36-35.895,4.974-53.239,5.434"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="
   M192.254,259.409c-16.64,3.002-34.502,4.688-53.239,5.434"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M93.812,252.117
   c0,0-22.907-2.66-47.796-10.852"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeMiterlimit="10"
          strokeDasharray="1.209,1.208"
          d="M92.845,256.11
   c0,0-22.852-2.669-47.741-10.861"
        />

        <polyline
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.45"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          points="
   119.61,131.932 118.684,132.858 119.61,132.858 118.721,133.747 119.61,133.747 118.499,134.858 119.61,134.858 118.48,135.988 
   119.61,135.988 118.517,137.08 119.61,137.08 	"
        />
        <path
          fill="#010101"
          d="M249.61,472.538c-0.43-8.74-7.13-61.78-7.2-62.31c-0.04-0.42-4.39-42.21-7.2-59.91
   c-1.79-11.29-5.27-25.36-7.87-35.18c-1.42-5.35-2.1-10.88-2.03-16.43c0.14-9.97,0.25-22.65-0.02-26.37
   c-0.32-4.27-1.29-19.11-0.48-30.95c0.14-1.94,0.32-4.31,0.52-7.02c0.96-12.59,2.56-33.67,2.47-52.34
   c-0.09-18.08,0.86-30.26,1.27-34.66c0.08-0.83,0.23-1.65,0.44-2.44c2.07-7.58,11.12-47.72-14.18-94.17l-3.25-6.94
   c0.02-0.09,0.01-0.2-0.04-0.34c-1.35-3.41-2.4-7.25-3.31-12.1l-0.33-1.6c-0.28-1.4-0.56-2.8-0.82-4.2
   c-0.17-0.9-0.37-1.58-0.83-1.99c-0.47-0.43-1.14-0.53-2.17-0.33c-24.39,4.58-46.63,9.73-68,15.74c-2.88,0.82-5.75,1.6-8.6,2.38
   c-6.91,1.9-14.05,3.86-21.13,6.12c-0.35,0.14-0.59,0.48-0.59,0.86v19.11h0.02c0.08,2.96,0.57,21.5,1.04,36.44l0.01,0.27l-0.81,1.38
   c-0.8,1.38-1.59,2.77-2.39,4.16c-1.24,2.18-2.47,4.37-3.69,6.57c-1.61,2.88-3.2,5.77-4.77,8.67c-1.88,3.46-3.77,6.99-5.62,10.49
   c-2.1,4-4.2,8.03-6.21,11.99c-2.26,4.44-4.48,8.88-6.59,13.2c-2.33,4.75-4.59,9.5-6.73,14.1c-2.32,4.99-4.55,9.94-6.64,14.72
   c-2.24,5.14-4.36,10.2-6.3,15.03c-2.12,5.26-4,10.18-5.75,15.04c-1.87,5.19-3.49,10.01-4.95,14.76c-1.55,5.02-2.83,9.65-3.92,14.16
   l-0.15,0.61c-1.08,4.48-2.2,9.1-2.62,13.69c-0.22,2.35-0.19,4.73-0.16,7.03c0.01,0.77,0.02,1.53,0.02,2.29l0.02,4.76
   c0.01,3.87,0.02,7.75,0.04,11.63c0.02,4.56,0.05,9.12,0.08,13.68c0.04,4.93,0.08,9.87,0.13,14.8c0.05,4.99,0.11,9.99,0.18,14.98
   c0.07,4.74,0.15,9.48,0.24,14.22c0.1,4.85,0.21,8.83,0.32,12.54c0.1,2.93,0.22,6.41,0.41,9.91l0.01,0.22
   c0.11,2.02,0.22,4.1,0.48,6.14c0.05,0.34,0.1,0.68,0.16,1.01c1.88,9.72,1.89,29.87,0.98,38.2c-0.87,7.9,1.18,32.76,1.2,33.01
   l0.01,0.18l0.17,0.08c0.09,0.05,9.77,4.85,25.07,4.85c0.49,0,0.98,0,1.48-0.01c15.25-0.31,25.45-0.73,35.6-2.09
   c9.67-1.29,10.38-3.59,10.43-3.91c0-0.35,0.12-35.51,1.2-50.6c0.63-8.76,1.17-18.19,1.67-28.85c0.36-7.68,0.71-15.87,0.83-24.1
   c0.05-3.48,0-6.99-0.04-10.39c-0.1-7.36-0.2-14.97,0.69-22.53c1.71-14.56,4.69-29.14,7.56-43.25l1.04-5.1
   c0.85-4.19,2.2-8.64,5.67-10.28c0.64,3.22,4.86,24.8,5.61,31.16c0.74,6.34,5.33,42.38,6.31,50.01
   c0.97,7.57,12.34,59.26,12.46,59.78c0.09,0.39,9.28,38.57,10.68,54.72c1.42,16.37,4.81,31.3,5.42,32.04
   c0.45,0.53,8.59,2.99,21.13,3.4c1.14,0.04,2.34,0.06,3.6,0.06c11.72,0,28.74-1.82,48.52-9.48l0.22-0.08L249.61,472.538z
    M228.89,144.758c-0.23,0.83-0.39,1.69-0.47,2.55c-0.01,0.17-0.03,0.37-0.05,0.56l-21.36,2.15c-0.9-0.88-7.15-7.08-7.9-7.84
   l-4.59-45.19c1.16,0.88,2.74,2.07,2.76,2.09c3.17,2.39,3.91,2.95,4.17,3.01v0.01l29.4-2.94
   C234.15,122.748,230.17,140.058,228.89,144.758 M230.75,98.518l-29.24,2.93c-0.72-0.53-5.31-4.01-7.08-5.35l-0.01-0.03h-0.03
   c-0.26-0.19-0.46-0.35-0.57-0.43l-2.18-21.58l32.07-3.22C227.32,80.678,229.52,89.998,230.75,98.518 M223.48,70.208l-31.91,3.21
   l-0.08-0.84l31.71-3.11C223.3,69.718,223.39,69.968,223.48,70.208 M204.7,23.898c1.05-0.2,1.41-0.01,1.62,0.17
   c0.32,0.29,0.48,0.86,0.62,1.63c0.27,1.4,0.54,2.81,0.83,4.21l0.32,1.6c0.9,4.81,1.95,8.65,3.3,12.1
   c-0.18,0.02-0.37,0.04-0.55,0.07c-0.5,0.07-1,0.15-1.5,0.23l-14.49,2.4c-1.51,0.26-3.02,0.51-4.53,0.77
   c-0.09,0.02-0.37,0.07-0.65,0.13c-0.29,0.06-0.58,0.12-0.67,0.14l-0.73,0.12c-0.17-0.91-2.54-13.4-3.58-16
   c-0.67-1.69-1.8-2.58-2.6-3.02C189.44,26.868,196.95,25.348,204.7,23.898 M181.01,28.678c0.01,0.01,0.53,0.15,1.18,0.6
   c0.65,0.45,1.41,1.2,1.9,2.43c1.03,2.59,3.53,15.79,3.55,15.92c0.17,0.93,0.25,2.39-0.08,2.89l-8.15,1.59
   c-0.16,0.03-0.27-0.03-0.28-0.05c0.2-1.03-0.08-2.57-0.1-2.64c-0.1-0.53-2.51-12.96-3.53-15.52c-0.72-1.82-2.01-2.87-2.78-3.38
   C175.46,29.898,178.22,29.278,181.01,28.678 M137.02,39.558c11.29-3.18,22.83-6.1,34.79-8.84v0.02c0.02,0.01,2.13,1,3.09,3.4
   c0.89,2.26,3.01,12.9,3.42,15.03l-2.15,0.38c-1.5,0.26-3,0.53-4.51,0.81c-3.06,0.56-8.05,1.63-13.34,2.88l-5.13,1.2
   c-4.24,1.04-9.1,2.27-14.43,3.66c-0.65-3.18-2.44-12.11-2.59-14.3C136.03,41.578,136.8,39.968,137.02,39.558 M174.67,50.478
   c7.49,27.47,6.72,38.19,2.81,70.16c-16.64-13.6-25.93-52.19-28.53-64.48c1.53-0.38,3-0.74,4.39-1.09l5.13-1.2
   c5.28-1.24,10.26-2.32,13.31-2.87C172.74,50.818,173.71,50.648,174.67,50.478 M136.2,39.788c-0.34,0.78-0.8,2.21-0.67,4.05
   c0.18,2.71,2.72,15,2.82,15.53c0.02,0.06,0.34,1.58,0.82,2.46c0.02,0.03,0.01,0.07,0,0.09c0,0.01-0.03,0.05-0.08,0.07l-5.75,1.19
   c-0.35-0.4-0.76-1.7-0.94-2.58c-0.03-0.13-2.64-12.77-2.82-15.43c-0.15-2.22,0.68-3.5,0.89-3.8
   C132.38,40.848,134.28,40.318,136.2,39.788 M106.92,48.358c0-0.11,0.06-0.21,0.15-0.24c7.04-2.26,14.18-4.22,21.08-6.11
   c0.47-0.13,0.95-0.26,1.42-0.39c-0.35,0.7-0.75,1.89-0.64,3.59c0.16,2.35,2.1,11.95,2.67,14.76c-12.05,3.17-22.51,6.05-24.68,6.65
   V48.358z M71.02,451.618c-14.88,0.3-24.73-4.05-26.09-4.69c-0.19-2.31-2.01-25.22-1.18-32.7c0.82-7.5,1.07-27.77-0.99-38.39
   c-0.06-0.32-0.11-0.65-0.15-0.98c-0.26-2.01-0.38-4.08-0.48-6.09l-0.02-0.22c-0.18-3.49-0.31-6.96-0.4-9.89
   c-0.11-3.71-0.22-7.69-0.32-12.53c-0.09-4.74-0.17-9.48-0.24-14.22c-0.07-4.99-0.13-9.99-0.18-14.98
   c-0.05-4.93-0.09-9.86-0.13-14.8c-0.03-4.56-0.06-9.12-0.08-13.68c-0.02-3.87-0.03-7.75-0.04-11.63l-0.02-4.75
   c0-0.77-0.01-1.53-0.02-2.3c-0.03-2.28-0.06-4.64,0.15-6.96c0.42-4.54,1.54-9.14,2.61-13.6l0.15-0.6c1.09-4.5,2.37-9.12,3.91-14.13
   c1.46-4.74,3.08-9.55,4.94-14.73c1.75-4.86,3.63-9.77,5.74-15.02c1.94-4.82,4.06-9.87,6.3-15.01c2.08-4.77,4.31-9.72,6.63-14.7
   c2.14-4.61,4.4-9.35,6.72-14.1c2.11-4.31,4.33-8.75,6.59-13.19c2.01-3.95,4.1-7.98,6.21-11.98c1.84-3.5,3.73-7.02,5.61-10.48
   c1.57-2.89,3.16-5.78,4.76-8.67c1.23-2.19,2.46-4.38,3.7-6.56c0.79-1.39,1.58-2.77,2.39-4.15c0.09-0.16,0.18-0.32,0.27-0.48
   c0.26,8.25,0.51,15.16,0.65,17.29c0.44,6.51,2.97,27.65,5.79,42.7c0.03,0.16,0.61,4.13-5.76,30.68
   c-10.16,23.23-17.63,80.68-17.7,81.3c-0.01,0.25-0.49,25.52-4.58,54.4c-3.98,28.06-2.03,113.54-1.89,119.49
   C79.97,451.408,75.74,451.518,71.02,451.618 M129.38,261.318l-1.04,5.1c-2.88,14.12-5.86,28.72-7.57,43.3
   c-0.9,7.61-0.8,15.24-0.7,22.62c0.04,3.39,0.09,6.89,0.04,10.37c-0.12,8.22-0.47,16.4-0.83,24.08c-0.5,10.65-1.04,20.08-1.67,28.83
   c-1.08,15.11-1.2,50.29-1.19,50.57c-0.01,0.02-0.72,2.12-9.87,3.34c-6.82,0.91-13.65,1.4-22.03,1.72
   c-0.14-6.02-2.09-91.39,1.88-119.38c4.1-28.92,4.58-54.23,4.58-54.44c0.08-0.58,7.53-57.94,17.67-81.14
   c4.21-17.55,5.41-25.32,5.72-28.65l2.51,9.84c0.32,1.24,1.36,5.09,2.81,10.41c4.87,17.93,16.18,59.61,16.01,62.55
   C131.74,252.078,130.28,256.848,129.38,261.318 M176.67,478.468c-0.5-0.76-3.87-15.38-5.28-31.68
   c-1.4-16.21-10.61-54.44-10.7-54.81c-0.11-0.52-11.48-52.18-12.45-59.72c-0.98-7.63-5.56-43.67-6.31-50
   c-0.79-6.75-5.46-30.44-5.68-31.57c0.26-1.59-1.79-10.88-15.93-62.97c-1.45-5.32-2.49-9.17-2.81-10.4l-3.08-12.05
   c-2.8-15.02-5.33-36.12-5.77-42.61c-0.15-2.25-0.42-9.84-0.69-18.72l-1.05-36.65c1.71-0.47,12.41-3.42,24.81-6.68
   c0.02,0.05,0.03,0.1,0.03,0.12c0.09,0.43,0.58,2.59,1.31,3.07l0.12,0.07l6.03-1.25c0.24-0.05,0.44-0.21,0.54-0.43
   c0.1-0.22,0.1-0.46-0.02-0.67c-0.43-0.8-0.75-2.27-0.75-2.29c0-0.01-0.04-0.19-0.1-0.49c3.34-0.87,6.5-1.68,9.43-2.42
   c2.63,12.45,12.08,51.65,29.09,65.12l2.22,31.04l-40.33,4.6l0.26,2.27l0.04-0.01c-0.02,0.06-0.02,0.12-0.02,0.19l3.69,31.48
   c0.01,0.09,0.04,0.17,0.09,0.25c0.17,0.22,0.78,0.8,1.72,1.68l-0.64,0.07c1.69,14.67,3.52,30.19,4.85,41.53
   c0.74,6.29,1.3,11.06,1.55,13.21l0.14,1.75l28.63-3.49l10.94-1.18c3.22,26.92,5.32,42.12,8.53,55.4
   c11.25,46.59,26.87,172.07,27.69,178.72C196.44,485.328,176.8,478.548,176.67,478.468 M190.28,162.578l20.24-2.31
   c1.61,13.45,5.23,45.93,7.4,65.39c0.81,7.26,1.44,12.89,1.72,15.37l-40.1,4.33l-27.96,3.41l-0.09-1.08
   c-0.25-2.17-0.81-6.93-1.55-13.23c-1.34-11.33-3.17-26.85-4.85-41.52c0.18,0.17,0.35,0.32,0.55,0.51c1.24,1.15,2.78,2.58,3.08,3
   c0.1,0.14,0.25,0.21,0.4,0.21h0.06l38.26-4.53c0.16-0.02,0.31-0.12,0.38-0.26c0.23-0.48,1.74-2.36,2.94-3.87
   c1.18-1.47,1.91-2.39,2.08-2.69c0.05-0.1,0.07-0.2,0.06-0.31L190.28,162.578z M192.25,185.028c-0.21,0.33-1.12,1.47-2,2.57
   c-1.53,1.92-2.65,3.34-2.97,3.9l-38.08,4.5c-0.43-0.53-1.79-1.8-3.12-3.02c-0.99-0.93-2.02-1.88-2.17-2.04l-3.66-31.35l48.35-5.74
   L192.25,185.028z M140.17,158.948l-0.15-1.29l48.38-5.53l0.13,1.08L140.17,158.948z M227.41,478.798
   c-0.91-7.32-16.47-132.23-27.7-178.72c-3.2-13.25-5.3-28.43-8.51-55.32l28.49-3.08l0.67-0.14l-0.04-0.29
   c-0.26-2.31-0.91-8.1-1.75-15.66c-2.19-19.62-5.86-52.47-7.45-65.72l-0.04-0.32l-20.88,2.38l-0.97-8.3
   c-0.01-0.06-0.03-0.12-0.06-0.17h0.04l-0.23-2.05l-8.7,0.99l-2.23-31.11c3.9-31.81,4.78-43.29-2.73-70.93
   c0.32-0.06,0.64-0.12,0.97-0.17l2.15-0.38c0.07,0.46,0.18,1.44,0.05,2.12c-0.05,0.22,0.02,0.43,0.18,0.59
   c0.16,0.16,0.4,0.25,0.65,0.25c0.08,0,0.15-0.01,0.22-0.02l8.36-1.64l0.08-0.07c0.57-0.61,0.49-2.06,0.39-2.93l0.74-0.12
   c0.09-0.02,0.39-0.08,0.69-0.14c0.27-0.06,0.54-0.11,0.63-0.13c1.51-0.26,3.02-0.51,4.53-0.77l14.49-2.4
   c0.49-0.08,0.99-0.16,1.49-0.23c0.21-0.03,0.41-0.06,0.62-0.08l3.19,6.81c3.3,6.06,6,12.01,8.22,17.79l-32.19,3.16l0.15,1.48h-0.01
   l2.28,22.49l0.09,0.08c0.02,0.02,0.22,0.17,0.52,0.4l4.68,45.98c0.03,0.09,8.15,8.17,8.27,8.23l0.08,0.03l21.47-2.16
   c-0.45,5.19-1.25,16.84-1.16,33.5c0.09,18.65-1.51,39.71-2.47,52.29c-0.2,2.71-0.38,5.09-0.52,7.02
   c-0.81,11.88,0.16,26.77,0.48,31.05c0.29,3.89,0.14,18.16,0.02,26.31c-0.07,5.61,0.61,11.19,2.05,16.61
   c2.13,8.02,5.98,23.26,7.86,35.11c2.8,17.68,7.15,59.46,7.2,59.89c0.06,0.53,6.65,52.64,7.18,62.03
   C241.32,475.278,234.11,477.358,227.41,478.798"
        />
        <path
          fill="#010101"
          d="M482.05,185.097c-0.27-11.88-0.53-23.3-0.76-33.66c-0.09-4.34-0.18-8.49-0.25-12.41
   c-0.8-40.59-5.74-68.72-9.74-85.17c-0.85-3.47-1.18-7.11-1.01-10.81c0.45-9.46-1.33-18.99-1.93-20.96v-0.08h-0.02
   c-0.06-0.17-0.1-0.26-0.13-0.28l-0.1-0.06l-0.06-0.04l-0.04,0.02c-83.82-16.61-161.56-0.74-165.03-0.01l-0.02-0.01l-0.06,0.03
   c-0.01,0-0.03,0.01-0.04,0.01v0.01l-0.07,0.04c-0.03,0.02-0.07,0.12-0.13,0.29l-0.02,0.08c-0.58,1.83-2.11,10.26-2,18.71
   c0.07,5.57-0.5,11.04-1.69,16.24c-3.68,16.09-8.23,43.37-8.99,81.99c-0.26,13.3-0.63,29.23-1.01,46.09
   c-1.39,60.59-2.95,129.27-1.34,137.33c0.8,3.99,0.93,26.54,1.09,52.65c0.25,41.67,0.56,93.53,3.64,101.87l0.05,0.15l0.16,0.04
   c0.2,0.07,13.48,4.06,34.1,4.06c10.36,0,22.59-1.01,35.93-4.04c0.33,0,0.33,0,0.62-5.15c0.17-3.08,0.4-7.48,0.68-12.75
   c0.55-10.56,1.27-24.64,1.99-38.71c1.44-28.15,2.86-56.31,2.86-56.31c0.03-0.83,3.52-83.83,2.65-118.2
   c1.16-26.2,7.3-51.57,7.37-51.89c0.59-15.38,2.87-38.32,6.75-38.59c3.81,0.26,6.07,22.35,6.72,37.77c0,0.09-0.01,0.16-0.01,0.17
   h0.02c0.01,0.24,0.02,0.48,0.03,0.72c0.06,0.25,6.19,25.62,7.36,51.79c-0.88,34.4,2.62,117.4,2.65,118.23
   c0,0,1.42,28.16,2.86,56.31c0.72,14.07,1.44,28.15,1.99,38.71c0.28,5.27,0.51,9.67,0.68,12.75c0.29,5.15,0.27,5.15,0.55,5.14
   c39.93,9.05,69.8,0.09,70.1-0.01l0.15-0.04l0.06-0.15c3.08-8.34,3.39-60.2,3.64-101.87c0.16-26.11,0.29-48.66,1.09-52.65
   C485,314.387,483.43,245.707,482.05,185.097 M482.71,245.787c-7.6,0.06-16.06,0.09-24.24,0.12c-6.8,0.02-13.56,0.04-19.83,0.08
   v-0.02c0.02-0.49,0.04-1.26,0-1.75v-0.19h-0.02c0-0.01,0-0.03-0.01-0.04c-0.21-21.68-0.16-45.54-0.1-58.46
   c0.25,0.22,0.51,0.47,0.8,0.74c1.4,1.28,3.13,2.87,3.45,3.33c0.1,0.14,0.27,0.22,0.45,0.22l38.29-0.14
   C481.92,207.997,482.36,227.507,482.71,245.787 M481.4,185.117c0.03,1.29,0.06,2.6,0.09,3.91l-38.23,0.14
   c-0.43-0.55-1.99-1.99-3.51-3.38c-1.07-0.99-2.17-2-2.42-2.31l-0.11-31.49l43.43-0.19C480.87,162.067,481.13,173.367,481.4,185.117
    M480.64,151.147l-43.39,0.19c0-0.06,0.01-0.1,0.01-0.16c0.03-0.36,0.08-0.96,0.17-1.15h43.18
   C480.62,150.407,480.63,150.767,480.64,151.147 M470.67,54.007c3.14,12.92,6.86,33.05,8.69,60.77c-0.39-0.96-0.78-1.91-1.15-2.86
   c-0.22-0.56-0.44-1.12-0.65-1.68c-0.34-0.88-0.68-1.76-1.01-2.63c-0.28-0.76-0.57-1.53-0.85-2.3c-0.19-0.51-0.37-1.03-0.55-1.54
   c-6.05-16.91-11.07-35.93-15.23-57.72l1.12-0.02c4.29-0.06,7.77-0.09,8.57-0.1C469.68,48.687,470.03,51.397,470.67,54.007
    M469.64,43.007c-0.03,0.76-0.03,1.52-0.03,2.27c-0.79,0.01-4.27,0.04-8.58,0.1l-18.57,0.29v-19.4l16.17,0.12
   c0.27,0,6.56,0.02,9.28-3.59C468.46,25.297,470.07,34.077,469.64,43.007 M467.51,22.207c-2.45,3.54-8.81,3.52-8.87,3.53
   l-73.15-0.52l-73.48,0.74c-0.06,0-6.11-0.19-8.53-3.76C310.15,20.837,385.88,6.127,467.51,22.207 M441.81,26.267v21.18
   c0,0.35-0.29,0.64-0.65,0.64H428.1c-0.36,0-0.65-0.29-0.65-0.64v-21.28L441.81,26.267z M370.19,40.967c0.54,1,1.09,2.01,1.63,3.01
   c0.5,0.9,0.99,1.81,1.48,2.72c-8.44,0.01-18.4-0.1-29.78-0.31v-20.1l30.24-0.3l-3,5.2c-0.81,1.4-1.49,2.7-1.64,4.44
   C368.96,37.467,369.34,39.367,370.19,40.967 M342.87,26.297v21.15c0,0.35-0.29,0.64-0.65,0.64h-13.06c-0.36,0-0.65-0.29-0.65-0.64
   v-21.01L342.87,26.297z M303.09,22.797c2.69,3.63,8.64,3.8,8.92,3.81l15.85-0.16v19.59c-4.48-0.12-8.63-0.23-12.24-0.34l-5.79-0.21
   c-4.67-0.15-8.58-0.21-8.61-0.21h-0.01c0.07-1.49,0.1-2.98,0.08-4.49C301.19,32.637,302.59,25.087,303.09,22.797 M299.58,57.187
   c0.84-3.65,1.37-7.42,1.59-11.26h0.04c0.04,0,3.94,0.06,8.6,0.21l1.15,0.04c-4.16,21.76-9.17,40.75-15.21,57.63
   c-0.18,0.49-0.35,0.99-0.54,1.48c-0.28,0.79-0.57,1.56-0.86,2.34c-0.33,0.86-0.65,1.72-0.99,2.59c-0.22,0.57-0.44,1.14-0.66,1.71
   c-0.34,0.85-0.69,1.71-1.04,2.57C293.39,88.677,296.74,69.587,299.58,57.187 M290.38,150.027h46.25v1.31l-46.27-0.17
   C290.37,150.787,290.38,150.407,290.38,150.027 M289.6,185.127c0.27-11.75,0.53-23.04,0.75-33.31l46.27,0.17l-0.1,31.49
   c-0.26,0.31-1.36,1.32-2.43,2.31c-1.52,1.39-3.08,2.83-3.5,3.38l-41.08-0.12C289.54,187.737,289.57,186.427,289.6,185.127
    M289.49,189.697l41.14,0.12c0.19,0,0.35-0.08,0.45-0.22c0.32-0.46,2.06-2.05,3.45-3.33c0.29-0.27,0.55-0.51,0.8-0.74
   c-0.02,13.86-0.06,31.82-0.09,45.3c-0.02,8.68-0.03,15.49-0.03,18.15l-15.56-0.09v-18.66c0.04-0.17,0.07-0.34,0.07-0.52v-31.79
   h7.65v50.9h0.65v-51.55h-8.3v-5.07H293.1v5.07h-3.78C289.38,194.727,289.44,192.197,289.49,189.697 M317.13,231.307h-21.44
   c-1.07,0-1.94-0.72-1.94-1.6v-36.86h25.32v36.86C319.07,230.587,318.2,231.307,317.13,231.307 M319,231.257v17.62l-19.55-0.12
   l-5.44,0.03v-17.38c0.45,0.34,1.03,0.55,1.68,0.55h21.44C317.87,231.957,318.53,231.687,319,231.257 M289.31,197.917h3.79v31.79
   c0,0.35,0.1,0.67,0.26,0.96v18.12l-5.13,0.02C288.54,232.357,288.92,214.797,289.31,197.917 M385.17,154.977
   c-4.27,1.17-6.09,22.01-6.75,32.92c-0.48-10.16-1.4-30.79-1.08-33.75c0.23-2.15,1.93-3.58,2.93-4.24c1.65-1.1,3.64-1.62,4.9-1.31
   V154.977z M385.17,147.937c-1.45-0.29-3.51,0.26-5.26,1.43c-1.88,1.25-3.02,2.92-3.21,4.71c-0.43,3.98,1.27,38.02,1.34,39.47h0.09
   c-0.01,0.21-0.02,0.4-0.02,0.53c-0.06,0.26-6.21,25.69-7.38,51.97c0.87,34.38-2.62,117.35-2.65,118.18
   c-0.06,1.09-5.39,106.92-5.8,112.36c-38.16,8.59-67.02,0.68-69.39,0c-2.99-8.7-3.29-60.12-3.54-101.49
   c-0.16-26.15-0.3-48.73-1.1-52.77c-1.02-5.1-0.73-36.13-0.04-72.87l11.24-0.05l36.41,0.23v-0.33c0-2.39,0.01-9.42,0.03-18.47
   c0.03-13.68,0.08-31.98,0.09-45.92c0.59-0.55,0.97-0.92,1.09-1.1c0.06-0.08,0.1-0.18,0.1-0.28l0.11-31.7
   c0-0.06-0.02-0.12-0.04-0.18h0.04v-2.28H290.4c0.07-3.59,0.15-7.04,0.21-10.34c0.16-7.98,0.48-15.46,0.92-22.48
   c0.6-1.44,1.19-2.91,1.77-4.39c0.23-0.57,0.45-1.15,0.67-1.72c0.33-0.86,0.66-1.72,0.98-2.59c0.3-0.78,0.59-1.57,0.88-2.35
   c0.17-0.49,0.35-0.98,0.52-1.47c7.94-22.09,12.45-43.06,15.27-57.84l3.98,0.15c3.62,0.11,7.77,0.22,12.26,0.34v0.76
   c0,0.71,0.58,1.29,1.3,1.29h13.06c0.72,0,1.3-0.58,1.3-1.29v-0.42c11.02,0.22,20.71,0.32,28.98,0.32c4.69,0,8.92-0.03,12.67-0.1
   V147.937z M385.49,46.587c-3.41,0.07-7.24,0.1-11.45,0.11c-0.54-1.01-1.1-2.03-1.65-3.03c-0.54-1-1.09-2-1.62-3
   c-0.79-1.49-1.15-3.26-1-4.98c0.14-1.61,0.78-2.84,1.55-4.17l3.2-5.53l10.39-0.11l0.59-0.01l41.3,0.29v19.74
   C409.83,46.157,395.93,46.397,385.49,46.587 M385.82,154.977v-6.4c1.28-0.26,3.2,0.26,4.81,1.33c1,0.66,2.7,2.09,2.93,4.24
   c0.31,2.87-0.55,22.43-1.03,32.85C391.82,175.847,389.98,156.117,385.82,154.977 M482.75,322.327c-0.81,4.04-0.94,26.62-1.1,52.77
   c-0.25,41.37-0.56,92.79-3.55,101.49c-2.36,0.68-31.18,8.58-69.38,0.01c-0.41-5.35-5.74-111.28-5.8-112.37
   c-0.03-0.83-3.53-83.8-2.65-118.2c-1.17-26.26-7.32-51.69-7.37-51.88c-0.01-0.18-0.02-0.44-0.03-0.74
   c0.13-2.59,1.76-35.43,1.34-39.33c-0.2-1.79-1.34-3.46-3.22-4.71c-1.71-1.14-3.72-1.69-5.17-1.45V47.237
   c10.4-0.2,24.18-0.43,40.98-0.69v0.9c0,0.71,0.58,1.29,1.3,1.29h13.06c0.72,0,1.3-0.58,1.3-1.29v-1.13l12.58-0.18l4.22-0.08
   c2.82,14.77,7.33,35.78,15.27,57.92c0.19,0.52,0.37,1.05,0.56,1.56c0.28,0.77,0.57,1.53,0.85,2.3c0.34,0.88,0.67,1.76,1.01,2.63
   c0.22,0.57,0.43,1.13,0.65,1.69c0.59,1.5,1.19,2.99,1.8,4.45l0.07-0.03c0.44,7.01,0.76,14.49,0.92,22.46
   c0.06,3.29,0.13,6.76,0.21,10.34h-43.25c-0.6,0-0.66,0.81-0.74,1.75c-0.01,0.17-0.03,0.34-0.04,0.5h0.05
   c-0.04,0.07-0.05,0.14-0.05,0.21l0.11,31.7c0,0.1,0.03,0.2,0.09,0.28c0.12,0.18,0.5,0.55,1.09,1.1
   c-0.06,13.23-0.12,38.79,0.13,61.4l0.02,1.59l0.52-1.27c6.31-0.04,13.1-0.06,19.94-0.08c8.19-0.03,16.65-0.06,24.26-0.12
   C483.46,284.487,483.8,317.087,482.75,322.327"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M310.96,46.177c-4.16,21.76-9.17,40.75-15.21,57.63c-0.18,0.49-0.35,0.99-0.54,1.48
   c-0.28,0.79-0.57,1.56-0.86,2.34c-0.33,0.86-0.65,1.72-0.99,2.59c-0.22,0.57-0.44,1.14-0.66,1.71c-0.34,0.85-0.69,1.71-1.04,2.57
   c1.73-25.82,5.08-44.91,7.92-57.31c0.84-3.65,1.37-7.42,1.59-11.26h0.04c0.04,0,3.94,0.06,8.6,0.21L310.96,46.177z"
        />
      </g>
    </svg>
  );
}
